/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateEmergencyLightCommandControllerCreate201,
  CreateEmergencyLightDto,
  EmergencyLightResponseDto,
  ListEmergencyLightsQueryControllerListParams,
  UpdateEmergencyLightCommandControllerUpdate200,
  UpdateEmergencyLightDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Register an emergency light for a nursery
 */
export const createEmergencyLightCommandControllerCreate = (
  nurseryId: string,
  createEmergencyLightDto: CreateEmergencyLightDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateEmergencyLightCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/emergency-lights`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEmergencyLightDto,
    signal,
  });
};

export const getCreateEmergencyLightCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEmergencyLightCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateEmergencyLightDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEmergencyLightCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateEmergencyLightDto },
  TContext
> => {
  const mutationKey = ["createEmergencyLightCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEmergencyLightCommandControllerCreate>>,
    { nurseryId: string; data: CreateEmergencyLightDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createEmergencyLightCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEmergencyLightCommandControllerCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createEmergencyLightCommandControllerCreate>>
  >;
export type CreateEmergencyLightCommandControllerCreateMutationBody =
  CreateEmergencyLightDto;
export type CreateEmergencyLightCommandControllerCreateMutationError = void;

/**
 * @summary Register an emergency light for a nursery
 */
export const useCreateEmergencyLightCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEmergencyLightCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateEmergencyLightDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEmergencyLightCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateEmergencyLightDto },
  TContext
> => {
  return useMutation(
    getCreateEmergencyLightCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List all emergency lights for a nursery
 */
export const listEmergencyLightsQueryControllerList = (
  nurseryId: string,
  params?: ListEmergencyLightsQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<EmergencyLightResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/emergency-lights`,
    method: "GET",
    params,
    signal,
  });
};

export const getListEmergencyLightsQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListEmergencyLightsQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/emergency-lights`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListEmergencyLightsQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListEmergencyLightsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEmergencyLightsQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>
  > = ({ signal }) =>
    listEmergencyLightsQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEmergencyLightsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>
>;
export type ListEmergencyLightsQueryControllerListQueryError = void;

export function useListEmergencyLightsQueryControllerList<
  TData = Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListEmergencyLightsQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEmergencyLightsQueryControllerList<
  TData = Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListEmergencyLightsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEmergencyLightsQueryControllerList<
  TData = Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListEmergencyLightsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all emergency lights for a nursery
 */

export function useListEmergencyLightsQueryControllerList<
  TData = Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListEmergencyLightsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmergencyLightsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListEmergencyLightsQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an emergency light
 */
export const updateEmergencyLightCommandControllerUpdate = (
  nurseryId: string,
  emergencyLightId: string,
  updateEmergencyLightDto: UpdateEmergencyLightDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateEmergencyLightCommandControllerUpdate200>({
    url: `/v1/nurseries/${nurseryId}/emergency-lights/${emergencyLightId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateEmergencyLightDto,
    signal,
  });
};

export const getUpdateEmergencyLightCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmergencyLightCommandControllerUpdate>>,
    TError,
    {
      nurseryId: string;
      emergencyLightId: string;
      data: UpdateEmergencyLightDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmergencyLightCommandControllerUpdate>>,
  TError,
  {
    nurseryId: string;
    emergencyLightId: string;
    data: UpdateEmergencyLightDto;
  },
  TContext
> => {
  const mutationKey = ["updateEmergencyLightCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmergencyLightCommandControllerUpdate>>,
    {
      nurseryId: string;
      emergencyLightId: string;
      data: UpdateEmergencyLightDto;
    }
  > = (props) => {
    const { nurseryId, emergencyLightId, data } = props ?? {};

    return updateEmergencyLightCommandControllerUpdate(
      nurseryId,
      emergencyLightId,
      data,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmergencyLightCommandControllerUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateEmergencyLightCommandControllerUpdate>>
  >;
export type UpdateEmergencyLightCommandControllerUpdateMutationBody =
  UpdateEmergencyLightDto;
export type UpdateEmergencyLightCommandControllerUpdateMutationError = void;

/**
 * @summary Update an emergency light
 */
export const useUpdateEmergencyLightCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEmergencyLightCommandControllerUpdate>>,
      TError,
      {
        nurseryId: string;
        emergencyLightId: string;
        data: UpdateEmergencyLightDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmergencyLightCommandControllerUpdate>>,
  TError,
  {
    nurseryId: string;
    emergencyLightId: string;
    data: UpdateEmergencyLightDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateEmergencyLightCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
